import clsx from "clsx";
import classes from "./RightSidebar.module.css";

import { Button, Dropdown, Text } from "components/common";
import Devider2 from "components/common/Devider2/Devider";
import Switch from "components/common/Switch/Switch";
import { useAppContext } from "ContextProvider/ContextProvider";

import { useEffect, useState } from "react";

const themeModes = ["Dark", "Light"];
const languages = ["Eng", "Hi", "Ben"];
const themeColors = [
  { name: "gora", color: "#00deff" },
  { name: "blue", color: "#418EE0" },
  { name: "pink", color: "#DA5397" },
  { name: "indigo", color: "#6165E8" },
  { name: "orange", color: "#E47934" },
  { name: "green", color: "#2F593F" },
];

const AppSettings = ({ sidebar, setSidebar }) => {
  const { myTheme, setMyTheme, allowEnterToSubmit, setAllowEnterToSubmit } =
    useAppContext();
  //theme mode dropdown
  const [showThemeModeDropdown, setShowThemeModeDropdown] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(
    localStorage.getItem("selectedTheme") || "Dark"
  );

  //select language dropdown
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "En"
  );

  // allow input history navigation
  const [allowInputHistoryNavigation, setAllowInputHistoryNavigation] =
    useState(
      JSON.parse(localStorage.getItem("allowInputHistoryNavigation")) || false
    );

  // allow telemetry Collection
  const [allowTelemetryCollection, setAllowTelemetryCollection] = useState(
    JSON.parse(localStorage.getItem("allowTelemetryCollection")) || false
  );

  const handleReset = () => {
    setMyTheme({
      name: "teal",
      color: "#0CE5A1",
    });
    setAllowEnterToSubmit(true);
    setSelectedTheme("Dark");
    setSelectedLanguage("En");
    setAllowInputHistoryNavigation(false);
    setAllowTelemetryCollection(false);

    localStorage.setItem("selectedTheme", "Dark");
    localStorage.setItem("selectedLanguage", "Eng");
    localStorage.setItem("allowInputHistoryNavigation", JSON.stringify(false));
    localStorage.setItem("allowTelemetryCollection", JSON.stringify(false));
  };
  useEffect(() => {
    localStorage.setItem("selectedTheme", selectedTheme);
    localStorage.setItem("selectedLanguage", selectedLanguage);
    localStorage.setItem(
      "allowInputHistoryNavigation",
      JSON.stringify(allowInputHistoryNavigation)
    );
    localStorage.setItem(
      "allowTelemetryCollection",
      JSON.stringify(allowTelemetryCollection)
    );
  }, [
    selectedTheme,
    selectedLanguage,
    allowInputHistoryNavigation,
    allowTelemetryCollection,
  ]);

  return (
    <>
      <div className={classes.spaceBetween}>
        <Text sm className={classes.label}>
          Press <span className={classes.highlight}>“Enter”</span> to Submits
          Chat
        </Text>
        <Switch
          isChecked={allowEnterToSubmit}
          setIsChecked={setAllowEnterToSubmit}
        />
      </div>
      {/* <div className={classes.spaceBetween}>
        <Text sm className={classes.label}>
          Input History Navigation
        </Text>
        <Switch
          isChecked={allowInputHistoryNavigation}
          setIsChecked={setAllowInputHistoryNavigation}
        />
      </div> */}
      <Devider2 />
      <div className={classes.selectBox}>
        {/* <Text primitive0 sm>
          Color Theme:
        </Text>
        <div className={classes.spaceBetween}>
          <Text sm className={classes.label}>
            Theme Mode
          </Text>
          <Dropdown
            className={classes.dropdown}
            items={themeModes}
            isActive={showThemeModeDropdown}
            setIsActive={setShowThemeModeDropdown}
            selectedValue={selectedTheme}
            setSelectedAiModel={setSelectedTheme}
            onSelect={(val) => setSelectedTheme(val)}
          />
        </div> */}

        <div className={classes.selectBox}>
          <Text primitive200 sm>
            Theme Color
          </Text>

          <div className={classes.allthemeColors}>
            {themeColors.map((theme, i) => (
              <button
                key={i}
                className={clsx(
                  classes.theme,
                  theme.name === myTheme.name && classes.activeTheme
                )}
                onClick={() => setMyTheme(theme)}
                style={{ "--color": theme.color }} // Set CSS variable dynamically
              >
                <div className={classes.themeBox}></div>
              </button>
            ))}
          </div>
        </div>
      </div>{" "}
      <Devider2 />
      <div className={classes.selectBox}>
        <Text primitive0 sm>
          Utility
        </Text>
        {/* <div className={classes.spaceBetween}>
          <Text className={classes.label}>Language</Text>
          <Dropdown
            className={classes.dropdown}
            items={languages}
            isActive={showLanguageDropdown}
            setIsActive={setShowLanguageDropdown}
            selectedValue={selectedLanguage}
            setSelectedAiModel={setSelectedLanguage}
            onSelect={(val) => setSelectedLanguage(val)}
          />
        </div> */}
        <div className={classes.spaceBetween}>
          <Text className={classes.label}>Telemetry Collection</Text>
          <Switch
            isChecked={allowTelemetryCollection}
            setIsChecked={() => {}}
            // setIsChecked={setAllowTelemetryCollection}
          />
        </div>
      </div>
      <Devider2 className={classes.devider} />
      <Button primitive800 onClick={handleReset}>
        Reset
      </Button>
    </>
  );
};
export default AppSettings;
